import { LeadDataProps, ThemeLanguage } from '../types/api';

/*
##### THEME #####
*/
export const THEME_BOX_STYLES = {
  ANGULAR: 'angular',
  ROUNDED: 'rounded',
} as const;
export const DEFAULT_BOX_STYLE = THEME_BOX_STYLES.ROUNDED;

export const THEME_EDIT_RIGHT_MODES = {
  NORMAL: 'normal',
  DISALLOW: 'disallow',
  ON_APPROVAL: 'on-approval',
} as const;
export const DEFAULT_EDIT_RIGHT_MODE = THEME_EDIT_RIGHT_MODES.NORMAL;

export const THEME_FILE_EDIT_MODES = {
  NORMAL: 'normal',
  DISALLOW: 'disallow',
  ON_APPROVAL: 'on-approval',
} as const;
export const DEFAULT_FILE_EDIT_MODE = THEME_FILE_EDIT_MODES.NORMAL;

export const THEME_LINK_EDIT_MODES = {
  NORMAL: 'normal',
  DISALLOW: 'disallow',
  ON_APPROVAL: 'on-approval',
} as const;
export const DEFAULT_LINK_EDIT_MODE = THEME_LINK_EDIT_MODES.NORMAL;

export const GLOBAL_DATA_POSITIONS = {
  BEFORE: 'before',
  AFTER: 'after',
} as const;
export const DEFAULT_GLOBAL_DATA_POSITION = GLOBAL_DATA_POSITIONS.BEFORE;

export const THEME_CONTACT_EXCHANGE_FLOWS = {
  BOTTOM_CARD_STATIC: 'bottomCardStatic',
  POPUP: 'popup',
} as const;
export const DEFAULT_THEME_CONTACT_EXCHANGE_FLOW = THEME_CONTACT_EXCHANGE_FLOWS.BOTTOM_CARD_STATIC;

/*
##### ACCOUNT #####
*/
export const ACCOUNT_STATUSES = {
  ACTIVE: 'active',
  INVITED: 'invited',
  UNINVITED: 'uninvited',
} as const;
export const DEFAULT_ACCOUNT_STATUS = ACCOUNT_STATUSES.UNINVITED;

export const ACCOUNT_ORIGINS = {
  CARD: 'card', // registered after tapping a card
  PLAIN: 'plain', // registered via signup form without a card
  SIGNUP2THEME: 'signup2theme',
  SIGNUP2UNIT: 'signup2unit',
  THEME: 'theme', // LEGACY DO NOT USE account created as part of a theme
  THEME_CSV_IMPORT: 'theme-csvimport',
  THEME_SINGLE: 'theme-single',
  SCIM: 'scim',
  AD_SYNC: 'ad-sync',
  S3_SYNC: 's3-sync',
} as const;

export const LEAD_ORIGINS = {
  MANUAL: 'manual',
  PROFILE_FORM: 'profile-form',
  LT2LT: 'lt2lt',
  SCANNER: 'scanner',
} as const;

export const LEAD_CUSTOM_FIELD_ORIGINS = {
  MANUAL: 'manual',
  CRM: 'crm',
} as const;

export const LEAD_CUSTOM_FIELD_REFERENCED_OBJECT_TYPES = {
  LEAD: 'lead',
  CONTACT: 'contact',
} as const;

export const LEAD_LIFECYCLE_EVENT_TYPES = {
  CREATED: 'created',
  UPDATED: 'updated',
  DELETED: 'deleted',
  EXPORTED: 'exported',
  EXPORTED_CRM: 'export-crm',
  ENRICH_STARTED: 'enrich-started',
  ENRICH_ENDED: 'enrich-ended',
  SCRAPE_STARTED: 'scrape-started',
  SCRAPE_ENDED: 'scrape-ended',
  EMAIL_SENT: 'email-sent',
  OWNER_CHANGED: 'owner-changed',
} as const;

export const ACCOUNT_FIELDS_MAX_LENGTH = {
  ID: 255,
  EMAILUSER: 64,
  EMAILDOMAIN: 256,
  EMAIL: 320,
  TEXT: 500,
  FIRSTNAME: 150,
  LASTNAME: 150,
  NUMBER: 100,
  URL: 2000,
  INTEGER: 2147483647, // integer postgress type max value
} as const;

// account roles
export const ROLES = {
  THEME_ADMIN: 'theme_admin',
  UNIT_ADMIN: 'unit_admin',
} as const;

/*
##### LINK TYPE #####
*/
export const LINK_TYPE_MODES = {
  LINK: 'link',
  USERNAME: 'username',
  PHONE: 'phone',
} as const;
export const DEFAULT_LINK_TYPE_MODE = LINK_TYPE_MODES.LINK;

/*
##### LINK TYPE #####
*/
export const LINK_CREATE_EDIT_MODES = {
  CUSTOM: 'custom',
  FROM_TEMPLATES: 'from-templates',
  ALL: 'all',
} as const;
export const DEFAULT_LINK_CREATE_EDIT_MODE = LINK_CREATE_EDIT_MODES.ALL;

/*
##### LEAD CUSTOM FIELDS #####
*/

export const UPSTREAM_LEAD_OBJECT_TYPES = {
  LEAD: 'lead',
  CONTACT: 'contact',
} as const;

export const LEAD_CUSTOM_FIELDS = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  DROPDOWN: 'dropdown',
  RADIO: 'radio',
  CHECKBOX_SINGLE: 'checkbox-single',
  CHECKBOX: 'checkbox',
  MULTI_SELECT: 'multi-select',
  DATE: 'date',
  DATETIME: 'datetime',
  NUMBER: 'number',
  ATTACHMENTS: 'attachments',
  SIGNATURE: 'signature',
} as const;
export const DEFAULT_LEAD_CUSTOM_FIELD = LEAD_CUSTOM_FIELDS.TEXTAREA;

/*
##### TIERS PLANS
*/
export const TIERS = {
  STARTER: 'starter',
  ESSENTIALS: 'essentials',
  PRO: 'pro',
  ENTERPRISE: 'enterprise',
} as const;
export type Tier = (typeof TIERS)[keyof typeof TIERS];
export const DEFAULT_TIER = TIERS.ESSENTIALS;

export const TIERS_LEVEL = ['starter', 'essentials', 'pro', 'enterprise'];

/*
##### Auth0
*/

export const AUTH0_PREFIX = 'auth0|' as const;

// https://auth0.com/docs/manage-users/user-migration/bulk-user-imports
export const AUTH0_IMPORT_ERR_CODES = {
  ANY_OF_MISSING: 'ANY_OF_MISSING',
  ARRAY_LENGTH_LONG: 'ARRAY_LENGTH_LONG',
  ARRAY_LENGTH_SHORT: 'ARRAY_LENGTH_SHORT',
  CONFLICT: 'CONFLICT',
  CONFLICT_EMAIL: 'CONFLICT_EMAIL',
  CONFLICT_USERNAME: 'CONFLICT_USERNAME',
  CONNECTION_NOT_FOUND: 'CONNECTION_NOT_FOUND',
  DUPLICATED_USER: 'DUPLICATED_USER',
  ENUM_MISMATCH: 'ENUM_MISMATCH',
  FORMAT: 'FORMAT',
  INVALID_TYPE: 'INVALID_TYPE',
  MAX_LENGTH: 'MAX_LENGTH',
  MAXIMUM: 'MAXIMUM',
  MFA_FACTORS_FAILED: 'MFA_FACTORS_FAILED',
  MIN_LENGTH: 'MIN_LENGTH',
  MINIMUM: 'MINIMUM',
  NOT_PASSED: 'NOT_PASSED',
  OBJECT_REQUIRED: 'OBJECT_REQUIRED',
  PATTERN: 'PATTERN',
} as const;

// https://auth0.com/docs/manage-users/user-migration/bulk-user-imports#create-users-json-file
export const AUTH0_IMPORT_FILE_SIZE = 500000;

/*
##### SSO
*/

// supported strategies
export const SSO_STRATEGIES = {
  SAMLP: 'samlp',
  OKTA: 'okta',
  OIDC: 'oidc',
  // microsoft azure entra id (active directory)
  ENTRA_ID: 'waad',
} as const;

// saml signature algorithms
export const SAML_SIGN_ALGORITHMS = {
  RSA_SHA1: 'rsa-sha1',
  RSA_SHA256: 'rsa-sha256',
} as const;

// saml digest algorithms
export const SAML_DIGEST_ALGORITHMS = {
  SHA1: 'sha1',
  SHA256: 'sha256',
} as const;

// active directory identity api
export const ENTRA_ID_API = {
  MICROSOFT_IDENTITY_PLATFORM: 'microsoft-identity-platform-v2.0',
  AZURE_ACTIVE_DIRECTORY: 'azure-active-directory-v1.0',
} as const;

/*
##### ACCOUNT STATE EVENT #####
*/

export const ACCOUNT_STATE_TRANSITION_TYPE = {
  DIRECT: 'direct',
  SIGNUP: 'signup',
  CREATION: 'creation',
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
  START_TRIAL: 'start-trial',
  END_TRIAL: 'end-trial',
  END_TRIAL_NON_MAIN: 'end-trial-non-main',
  ROLE_CHANGE: 'role-change',
  STATUS_CHANGE: 'status-change',
} as const;

export const TRIALSTATUS = {
  NONE: 'none',
  CURRENT: 'current',
  FINISHED: 'finished',
} as const;
export type TrialStatus = (typeof TRIALSTATUS)[keyof typeof TRIALSTATUS];
export const DEFAULT_TRIALSTATUS = TRIALSTATUS.NONE;

/**
 * File Generation entity
 */

export const FILE_GEN_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  PENDING: 'pending',
} as const;

export const FG_META_TYPES = {
  DESKTOP: 'qr-bg-desktop',
  MOBILE: 'qr-bg-mobile',
  PLAIN: 'qr-plain',
  WALLET_APPLE: 'wallet-apple',
  WALLET_GOOGLE: 'wallet-google',
} as const;

// theme languages default values
export const THEME_LANGUAGES_DEFAULTS: Array<ThemeLanguage> = [
  { lang: 'de', isInput: true, isFallback: false },
  { lang: 'en', isInput: false, isFallback: true },
];

export const LANGUAGE_ERROR_KEYS = {
  INVALID_CODE: 'invalid-language-iso-code',
  INVALID_INPUT_NUMBER: 'invalid-input-languages-number',
  INVALID_FALLBACK_NUMBER: 'invalid-fallback-languages-number',
} as const;

// CSV Actions
export const DEFAULT_CSV_ACTION_SETTINGS = {
  update: { useEmptyColumns: true },
} as const;

// lead columns with multilned text
export const LEAD_MULTILINE_FIELDS = ['company', 'role', 'division', 'position'] as Array<
  keyof LeadDataProps
>;

export const LEAD_DEFAULT_FIELDS = [
  'profileImageUrl',
  'notes',
  'namePrefix',
  'firstName',
  'lastName',
  'academicDegree',
  'position',
  'role',
  'company',
  'division',
  'email',
  'workEmail',
  'workPhone',
  'workFax',
  'mobilePhone',
  'birthday',
  'addressee',
  'addressLine1',
  'addressLine2',
  'postCode',
  'city',
  'country',
  'businessCardUrls',
  'website',
  'preferredLang',
  'gdprLegalBasis',
  'upstreamLeadObjectType',
  'createdOn',
  'linkedInLink',
  'numberOfEmployees',
  'via',
  'salutation',
] as Array<keyof LeadDataProps>;

export const SCANNABLE_FIELDS = [
  'email',
  'workEmail',
  'workPhone',
  'workFax',
  'mobilePhone',
  'website',
  'firstName',
  'lastName',
  'preferredLang',
  'position',
  'company',
  'addressLine1',
  'postCode',
  'city',
  'country',
  'salutation',
  'namePrefix',
] as const;

export const ENRICHABLE_FIELDS = [
  'firstName',
  'lastName',
  'email',
  'workEmail',
  'workPhone',
  'mobilePhone',
  'company',
  'website',
  'linkedInLink',
  'country',
  'salutation',
  'numberOfEmployees',
] as const;

export const SCRAPPABLE_FIELDS = [
  'firstName',
  'lastName',
  'company',
  'linkedInLink',
  'position',
  'city',
  'country',
  'website',
  'profileImageUrl',
  'numberOfEmployees',
] as const;

export const ACCOUNT_LIFECYCLE_EVENT_STATUS = [
  'approved',
  'pending',
  'rejected',
  'no_approval_needed',
] as const;

export const LEAD_ATTACHMENT_SUPPORTED_FORMATS = [
  {
    ext: 'jpg',
    mime: ['image/jpeg'],
  },
  {
    ext: 'png',
    mime: ['image/png'],
  },
  {
    ext: 'webp',
    mime: ['image/webp'],
  },
  {
    ext: 'pdf',
    mime: ['application/pdf'],
  },
  {
    ext: 'heic',
    mime: ['image/heic'],
  },
  {
    ext: 'mp4',
    mime: ['video/mp4'],
  },
  {
    ext: 'mov',
    mime: ['video/quicktime'],
  },
] as const;

export const LEAD_SIGNATURE_SUPPORTED_FORMATS = [
  {
    ext: 'png',
    mime: ['image/png'],
  },
] as const;
